export interface FixMessage {
  time: string;
  sender: string;
  target: string;
  message: string;
  messageType: string;
  messageTypeDescription: string;
  clorId: string;

  tags: FixMessageTag[];
}

export interface FixMessageTag {
  tag: number;
  tagDescription: string;
  tagDescriptionExplain: string;
  value: string | null;
  valueDescription: string;
  kind: FixMessageTagKind;
}

export interface FixMessageTagWithPadding extends FixMessageTag {
  padding: number;
}

export enum FixMessageTagKind {
  SYSTEM = "SYSTEM", // 35,150
  HEADER = "HEADER", // 8,9,35,49,56,34,52,10
  CUSTOM = "CUSTOM",
}

export interface FixTag {
  key: number;
  value: string | null;
}

export interface ParseResult<T> {
  source?: string;

  data?: T;
  errors: ParseError[];
}

export interface ParseError {
  code: string;
  message: string;
}

export enum ViewMode {
  VIEW = "VIEW",
  DIFF = "DIFF",
  TIMELINE = "TIMELINE",
  CODE = "CODE",
}
